<template>
  <v-container fluid fill-height class="grey lighten-3">
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-toolbar flat color="grey lighten-2">
          <v-toolbar-title>Item Master</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn rounded color="primary" dark @click="apiRequestCogsdata">Generate</v-btn>

          <download-excel 
            :data="json_data" 
            :fields="json_fields" 
            type="csv" 
            :name="fileName"
            :fetch="downloadExcelCogsdata">
            <v-btn fab flat medium color="black">
              <v-tooltip bottom>
                <v-icon slot="activator" color="green darken-4">fas fa-file-excel</v-icon>
                <span>Export</span>
              </v-tooltip>
            </v-btn>
          </download-excel>
        </v-toolbar>

        <loading :active.sync="isLoading" :is-full-page="true" color="#7f0000" loader="bars" />

        <back-to-top bottom="90px" right="90px">
          <v-btn class="red darken-4" dark absolute fab small>
            <v-icon>expand_less</v-icon>
          </v-btn>
        </back-to-top>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isLoading: false,
    fileName: null,
    json_data: null,
    Cogslist: [],
    json_fields: {
      "ID": "ID",
      "ITEMCODE": "ITEMCODE",
      "ITEMNAME": "ITEMNAME",
      "ITEMTYPE": "ITEMTYPE",
      "TOP": "TOP",
      "SECOND": "SECOND",
      "GROUP": "GROUP",
      "SUBGROUP": "SUBGROUP",
      "HSN": "HSN",
      "STATUS": "STATUS",
      "MANUFACTURER": "MANUFACTURER",
      "STRIPSIZE": "STRIPSIZE",
      "HSN_SAC": "HSN_SAC",
      "TAX": "TAX",
      "AUTOPRQMANUFACTURER": "AUTOPRQMANUFACTURER",
      "ISAUTOPRQENABLED": "ISAUTOPRQENABLED"
    }
  }),

  methods: {
    apiRequestCogsdata() {
      this.isLoading = true;
      this.axios
      .get("https://mis.dragarwal.com/api-itemmaster")
      // .get("http://localhost:8888/api-itemmaster")
        .then(response => {
          this.Cogslist = response.data.result['cogs'];
          this.json_data = this.Cogslist;
          // this.fileName = "ItemMaster.csv";
          const today = new Date();
const formattedDate = today.toISOString().slice(0, 10); // Format: YYYY-MM-DD
this.fileName = `ItemMaster_ason_${formattedDate}.csv`;

          alert("Data loaded... please download in Excel");
        })
        .catch(err => {
          console.error("API Error", err);
          alert("Error loading data.");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadExcelCogsdata() {
      return this.Cogslist || [];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/itemmaster.vue